import gql from "graphql-tag";
import {client} from "./client";
import {ILayerUpdateResponse} from "../types";
import {UpdateLayerByType} from "../../schema/UpdateLayerByType";

const getUpdateLayerMutation = (type: string, layerName: string): any => ({
    mutation: gql`${UpdateLayerByType}`,
    variables: {
        type,
        layerName,
    }
});

export async function updateLayerByType (type: string, layerName: string):
    Promise<{layername: string, type: string}> {
    const result: ILayerUpdateResponse = await client.mutate(getUpdateLayerMutation(type, layerName)) as any;
    const {layer} = result.data?.updateLayerByType!;
    if (!layer) {
        throw new Error('layer does not exist');
    } else {
        client.cache.reset();
        const {layername, type} = layer;
        return {layername, type};
    }
}
